import Alert from '@mui/material/Alert';
import Grid from '@mui/material/Grid';
import type { SxProps, Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { useDealContext } from '../../../../utils/context/DealContext.tsx';
import { useMapKeysToLabels } from './hooks/useMapKeysToLabels.ts';
import { useTargetingLabels } from './hooks/useTargetingLabels.tsx';

const styles: { [key: string]: SxProps<Theme> } = {
  alert: {
    margin: theme => theme.spacing(1, 0, 2.5),
    maxWidth: '100%',
    padding: theme => theme.spacing(2),
  },
  grid: {
    '& ul': {
      marginLeft: theme => theme.spacing(3),
    },
  },
};

export const UnusedParams = (): JSX.Element | null => {
  const { useDealForecast } = useDealContext();
  const {
    forecastState: { not_included_fields },
  } = useDealForecast();

  const { t } = useTranslation();
  const targetingLabels = useTargetingLabels(t);
  const params = useMapKeysToLabels(targetingLabels, not_included_fields);

  if (!not_included_fields?.length || !params?.length) {
    return null;
  }

  return (
    <Alert sx={styles.alert} severity="warning">
      <Typography data-test="unused-params-title">
        {t('Your targeting selections included below filters. These are not accounted for in Deal Plan:')}
      </Typography>
      <Grid data-test="unused-params-container" sx={styles.grid}>
        <ul>
          {params.map(param => (
            <li key={param} data-test="unused-param">
              {param}
            </li>
          ))}
        </ul>
      </Grid>
    </Alert>
  );
};
